<template>
  <div ref="text" class="text" data-aos="type" :data-aos-id="id">
    <text-glitch :parentGlitch="parentGlitch">
      > {{typedText}}
      <!-- <div class="caret" :class="caretClass"></div> -->
      <span :class="caretClass" class="caret">_</span>

      <span style="visibility:hidden">{{hiddenText}}</span>
    </text-glitch>
  </div>
</template>
<script>
/**
 * Types out text on the scroll on scroll
 */
const TYPE_SPEED = 10
import { Scramble } from "@/scripts/text-scrambler"
import RandomUtils from "@/scripts/utils/random"
import AsyncUtils from "@/scripts/utils/async"
import StoreUtils from "@/scripts/utils/store"

import { GetRandomChar, ReplaceChar } from "@/scripts/text-utility"
import TextGlitch from "./text-glitch"
import { mapState } from "vuex"
/**
 * Types out text based on scroll
 */
export default {
  components: {
    TextGlitch
  },
  props: {
    text: {
      type: String
    },
    parentGlitch: {
      type: Boolean
    },
    charWrite: {
      type: Number,
      default: 3,
    }
  },
  data() {
    return {
      // the actual index of the text we are writting until
      actualLetterIndex: 0,
      letterIndex: 0,
      actualText: "",
      timer: null,
      glitching: false,
      storeWatch: null
    }
  },
  computed: {
    // unique id
    id() {
      return "typer-" + this._uid
    },
    typedText() {
      return this.actualText.substr(0, this.actualLetterIndex)
    },
    hiddenText() {
      // NOTE: we add an invisible caret since we have to take in consideration the word wrapping with the caret
      return (
        this.actualText.substr(this.actualLetterIndex + 1, this.text.length) +
        " _"
      )
    },
    caretClass() {
      return this.glitching ? "pause-caret" : "unpause-caret"
    },
    ...mapState(["isMobile"])
  },
  methods: {
    /**
     * Scrambles the text
     * @param {Boolean} animated if we are animating it or glitching it
     */
    async scramble(animated) {
      const minFlicker = 1
      const maxFlicker = 3
      const flickerWait = 100

      let flicker = RandomUtils.RandomNumber(minFlicker, maxFlicker)
      // flicker random
      for (let i = 0; i < flicker; i++) {
        if (animated) {
          this.actualText = Scramble(this.text)
        } else {
          // increase scramble
          this.actualText = Scramble(this.text, 0.5, 0.75)
        }
        if (animated) {
          await AsyncUtils.Sleep(flickerWait)
        }
      }
    },
    unscramble() {
      this.actualText = this.text
    },
    // scrambles text for a glitch effect
    async scrambleRoutine() {
      // initial delay
      await AsyncUtils.Sleep(3000)
      const minWait = 20000
      const maxWait = 45000

      /* eslint-disable-next-line */
      while (true) {
        // reset
        this.unscramble()
        // wait
        let wait = RandomUtils.RandomNumber(minWait, maxWait)
        await AsyncUtils.Sleep(wait)
        // dont start scramble if currently in glitch
        if (!this.glitching) {
          await this.scramble(true)
        }
      }
    },
    // on hover for char
    hover(enable, i) {
      if (!enable) {
        this.actualText = this.text
      } else {
        this.actualText = ReplaceChar(this.actualText, i, GetRandomChar())
      }
    },
    /**
     * Sets index to full
     */
    type() {
      this.letterIndex = this.text.length - 1
      this.startTyping()
    },
    /**
     * Sets index to 0
     */
    untype() {
      this.letterIndex = 0
      this.startTyping()
    },
    /**
     * The interval for typing/untyping
     */
    startTyping() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // at goal
        if (this.actualLetterIndex === this.letterIndex) {
          clearInterval(this.timer)
          return
        }
        // convertge
        if (this.actualLetterIndex > this.letterIndex) {
          this.actualLetterIndex -= this.charWrite * 2
          if (this.actualLetterIndex < 0) {
            this.actualLetterIndex = 0
          }
        } else if (this.actualLetterIndex < this.letterIndex) {
          this.actualLetterIndex += this.charWrite
          if (this.actualLetterIndex > this.letterIndex) {
            this.actualLetterIndex = this.letterIndex
          }
        }
      }, TYPE_SPEED)
    }
  },
  created() {
    this.actualText = this.text
    if (!this.isMobile) {
      this.letterIndex = 0

      // begin type
      this.scrambleRoutine()
      document.addEventListener(`aos:in:${this.id}`, this.type)
      document.addEventListener(`aos:out:${this.id}`, this.untype)
    } else {
      this.letterIndex = this.text.length - 1
      this.actualLetterIndex = this.letterIndex
    }
    this.storeWatch = StoreUtils.WatchGlitch(
      () => {
        this.glitching = true
        this.scramble(false)
      },
      () => {
        this.glitching = false
        this.unscramble()
      }
    )
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (!this.isMobile) {
      document.removeEventListener(`aos:in:${this.id}`, this.type)
      document.removeEventListener(`aos:out:${this.id}`, this.untype)
    }
    this.storeWatch()
  }
}
</script>
<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";
.caret {
  position: relative;
  // left: -5px;
  // top: 2px;
  // width: 10px;
  // height: 25px;
  // display: inline-block;
  // background-color: $text-color;
}
.unpause-caret {
  opacity: 0;
  animation: fade 1s ease;
  animation-iteration-count: infinite;
}
.pause-caret {
  opacity: 1;
}

@keyframes fade {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>

